var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrowViolet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.99999C0 8.66847 0.131696 8.35053 0.366117 8.11611C0.600537 7.88169 0.918479 7.74999 1.25 7.74999H15.7325L10.365 2.38499C10.1303 2.15028 9.99842 1.83193 9.99842 1.49999C9.99842 1.16805 10.1303 0.849709 10.365 0.614992C10.5997 0.380276 10.9181 0.248413 11.25 0.248413C11.5819 0.248413 11.9003 0.380276 12.135 0.614992L19.635 8.11499C19.7514 8.23111 19.8438 8.36905 19.9068 8.52091C19.9698 8.67277 20.0022 8.83558 20.0022 8.99999C20.0022 9.16441 19.9698 9.32721 19.9068 9.47908C19.8438 9.63094 19.7514 9.76888 19.635 9.88499L12.135 17.385C11.9003 17.6197 11.5819 17.7516 11.25 17.7516C10.9181 17.7516 10.5997 17.6197 10.365 17.385C10.1303 17.1503 9.99842 16.8319 9.99842 16.5C9.99842 16.1681 10.1303 15.8497 10.365 15.615L15.7325 10.25H1.25C0.918479 10.25 0.600537 10.1183 0.366117 9.88388C0.131696 9.64946 0 9.33152 0 8.99999Z",
    fill: "#6E50BC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowViolet);
export default __webpack_public_path__ + "static/media/right-arrow-violet.8d767bd8491640f0f9ef06b76016c63d.svg";
export { ForwardRef as ReactComponent };